import { render, staticRenderFns } from "./PositionSkill.vue?vue&type=template&id=73684630&scoped=true"
import script from "./PositionSkill.vue?vue&type=script&lang=js"
export * from "./PositionSkill.vue?vue&type=script&lang=js"
import style0 from "./PositionSkill.vue?vue&type=style&index=0&id=73684630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73684630",
  null
  
)

export default component.exports